import BadgeListPage from './BadgeListPage';

export * from './types';

export default BadgeListPage;